import { PER_PAGE_FOR_CATALOG } from 'constants';
import { get, post, put } from './index';
import { OrderDirectionEnum, PromotionStateEnum } from '@koob/enums';

export const getPromotions = async ({
  productId,
  kind,
  mandatorySupplement,
  except = '',
  exceptIds = [],
  state = '',
  search = '',
  type = '',
  direction = OrderDirectionEnum.DESC,
  column = 'id',
  page = 1,
  perPage = PER_PAGE_FOR_CATALOG,
}) => {
  const params = new URLSearchParams({
    ...(kind && { kind }),
    ...(state && { state }),
    ...(mandatorySupplement !== undefined && {
      mandatorySupplement: mandatorySupplement,
    }),
    ...(except !== undefined && { exceptPromotionId: except }),
    ...(search && { search }),
    ...(type && { type }),
    column,
    direction: direction.toLowerCase(),
    page,
    perPage,
  });

  // Array query param, parsed server-side into `exceptPromotionIds: string[]`
  // (same convention as `countries[]` on /organizations/to).
  exceptIds.forEach((id) => params.append('exceptPromotionIds[]', id));

  return get(`/promotions/${productId}/list?${params.toString()}`);
};

export const getPromotion = async ({ id, skip }) => {
  if (skip) {
    return Promise.resolve(null);
  }
  return get(`/promotions/${id}`);
};

export const createPromotion = async (promotion) => {
  return post(`/promotions`, promotion);
};

export const updatePromotion = async (promotionId, promotion) => {
  return put(`/promotions/${promotionId}`, promotion);
};

export const distributePromotions = (payload) =>
  post(`/promotions/bulk-edit`, payload);

export const getPromotionStateCounts = async ({ productId, kind }) => {
  const states = Object.values(PromotionStateEnum);

  const responses = await Promise.all(
    states.map((state) =>
      getPromotions({ productId, kind, state, perPage: 1 }),
    ),
  );

  return Object.fromEntries(
    states.map((state, index) => [
      state,
      Number(responses[index]?.headers?.xTotalCount ?? 0),
    ]),
  );
};
